import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled as muiStyled } from '@mui/material/styles';

import LogoTextImage from '../../../images/icons/logo-text.png';
import AppContainer from '~/src/usersite/components/AppContainer';

interface Props {
  message: string;
}

const ErrorContainer = ({ message }: Props) => {
  const { t } = useTranslation();
  return (
    <StyledContainer>
      <Stack direction="column" alignItems="center" spacing={4}>
        <Img src={LogoTextImage} alt={t('otetsutabi')} />
        <Typography component="h1" variant="h6" fontWeight="bold">
          {message}
        </Typography>
      </Stack>
    </StyledContainer>
  );
};

export default ErrorContainer;

const StyledContainer = muiStyled(AppContainer)(
  ({ theme }) => `
  &.MuiContainer-root {
    padding-top: ${theme.spacing(25)};
  }
`,
);

const Img = styled.img`
  width: 100%;
  max-width: 210px;
  height: auto;
`;
